"use strict";
exports.__esModule = true;
exports.RequiredActionAlias = void 0;
var RequiredActionAlias;
(function (RequiredActionAlias) {
    RequiredActionAlias["VERIFY_EMAIL"] = "VERIFY_EMAIL";
    RequiredActionAlias["UPDATE_PROFILE"] = "UPDATE_PROFILE";
    RequiredActionAlias["CONFIGURE_TOTP"] = "CONFIGURE_TOTP";
    RequiredActionAlias["UPDATE_PASSWORD"] = "UPDATE_PASSWORD";
    RequiredActionAlias["terms_and_conditions"] = "terms_and_conditions";
})(RequiredActionAlias = exports.RequiredActionAlias || (exports.RequiredActionAlias = {}));
//# sourceMappingURL=requiredActionProviderRepresentation.js.map